export const productNames = {
	WAC: 'marketing',
};

// https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/4954887423/Project+poster+Encourage+comment+response+in+Confluence+with+flags
export const COMMENT_NUDGE_EXP_TAP_AUDIENCE_ID =
	'segment_confluence_mau_not_mcu_with_user_tenure_greater_than_90_days_siteuser';
export const COMMENT_NUDGE_EXP_STATSIG_EXPERIMENT_NAME =
	'post-office_expt_confluence-comments-nudge';

export const PAYING_TENANTS_LESS_THAN_60_DAYS_OLD_TAP_AUDIENCE_ID =
	'segment_paying_tenants_less_than_60_days_old_siteid';

export const PARTNER_MANAGED_TENANTS_TAP_AUDIENCE_ID = 'segment_partner_managed_tenants_siteid';
